import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class ProductLocation extends Base {
  currentVaration = '';

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ProductLocation',
    refs: ['select', 'btn', 'alert'],
    options: {
      formUrl: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Detect change on select
   * @returns {void}
   */
  onSelectInput() {
    if (this.currentVariation !== '') {
      this.$refs.alert.classList.add('hidden');
    }
  }

  /**
   * get current selected option
   * @returns {string}
   */
  get currentVariation() {
    return this.$refs.select
      ? this.$refs.select.options[this.$refs.select.selectedIndex].value
      : '';
  }

  /**
   * Click on btn and redirect to form
   * @returns {void }
   */
  onBtnClick() {
    if (this.currentVariation === '' && this.$refs.select) {
      this.$refs.select.classList.add('border', 'border-red');
      this.$refs.alert.classList.remove('hidden');
      return;
    }

    window.location.href = this.$options.formUrl + this.currentVaration;
  }
}
